import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from "@mui/material";
import { tableHeaderStyles, tableCellStyles } from "../../../../utils/styles";

// Skeleton component for loading state
const VehicleAllocationSkeleton: React.FC = () => (
  <TableContainer component={Paper}>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell {...tableHeaderStyles}>Type</TableCell>
          <TableCell {...tableHeaderStyles}>Vehicle Details</TableCell>
          <TableCell {...tableHeaderStyles}>Assignment</TableCell>
          <TableCell {...tableHeaderStyles}>Status</TableCell>
          <TableCell {...tableHeaderStyles}>Start Date</TableCell>
          <TableCell {...tableHeaderStyles}>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(3)].map((_, index) => (
          <TableRow key={index}>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={60} height={20} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Box>
                <Skeleton variant="text" width={120} height={16} />
                <Skeleton variant="text" width={100} height={14} />
              </Box>
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Box>
                <Skeleton variant="text" width={140} height={16} />
                <Skeleton variant="text" width={100} height={14} />
              </Box>
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={60} height={20} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={80} height={16} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="circular" width={24} height={24} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default VehicleAllocationSkeleton;
